import { render, staticRenderFns } from "./SectionProductsAdditiveForm.vue?vue&type=template&id=7609be6f&"
import script from "./SectionProductsAdditiveForm.vue?vue&type=script&lang=js&"
export * from "./SectionProductsAdditiveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports